import type { ItemWithQuantity } from '~/types/halloween/items';
import type { HalloweenLocation } from '~/types/halloween/location';

export interface ExpeditionLog {
  text: string[];
  uniqueEventIndex: string;
  shouldPlayAnimation: boolean;
  timestampMs: number;
  image?: string;
  items?: ItemWithQuantity[];
}

export interface ParsedCharacterData {
  characterIndex: number;
  characterType: number; // 0-4 character index
  health: number; // 0-255
  attack: number; // 0-255
  defense: number; // 0-255
  pearlPrice: number;
  goldOrePrice: number;
  available: boolean;
}

export interface ExpeditionBaseState {
  startedAt: Date;
  durationSeconds: number;
  endsAt: Date;
  returningHome: boolean;
  returnsAt: Date;
  claimed: boolean;
  claimAvailable: boolean;
}

export interface ExpeditionExtendedState extends ExpeditionBaseState {
  expeditionId: number;
  characters: (Omit<ParsedCharacterData, 'available'> & {
    currentHealth: number;
    alive: boolean;
  })[];
  logs: ExpeditionLog[];
  inventory: ItemWithQuantity[];
  location: HalloweenLocation;
  seasonPoints: number;
}

export enum ExpeditionStatus {
  STARTED, // started but not interrupted
  // return with events
  INTERRUPTED, // interrupted in middle of expedition
  // return without events
  RETURNS, // returning after successful expedition
  ENDED, // ended after returns
  CLAIMED // claimed after ended
}
